// @flow

import React, { useContext } from 'react';

import Responsive from 'Components/utils/responsive/responsiveContext';

import { OffersPushLineNarrow } from 'Components/lines/offers-push-line/OffersPushLineNarrow';
import { OffersPushLineLarge } from 'Components/lines/offers-push-line/OffersPushLineLarge';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';

type Props = CMSOffersPush;

export const OffersPushLine = (props: Props) => {
  const { isTablet } = useContext(Responsive);

  return (
    <SiteContainer className="Line" id={props.id}>
      {isTablet ? <OffersPushLineLarge {...props} /> : <OffersPushLineNarrow {...props} />}
    </SiteContainer>
  );
};
